const SESSION_KEY = {
  oidcSessionKey: 'oidc.login.default',
  smartBannerDismissed: 'smartBanner',
  kakiAIChatbot: 'ai-chatbot-kaki',
  standardHealthProfile: 'standard-health-page',
};

export { SESSION_KEY };
